export enum StorageType {
    Local, Session
}